import type {Tree, TreeLeaf} from '../types';

const areLeafNodesEqual = (leaf1: TreeLeaf, leaf2: TreeLeaf): boolean => {
  if (leaf1.length !== leaf2.length) {
    return false;
  }
  for (let i = 0; i < leaf1.length; i++) {
    if (leaf1[i] !== leaf2[i]) {
      return false;
    }
  }
  return true;
};

export const allLeafNodesEqual = (tree: Tree): boolean => {
  const keys = Object.keys(tree);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const value = tree[key];
    if (Array.isArray(value)) {
      for (let j = i + 1; j < keys.length; j++) {
        const otherKey = keys[j];
        const otherValue = tree[otherKey];
        if (
          Array.isArray(otherValue) &&
          !areLeafNodesEqual(value, otherValue)
        ) {
          return false;
        }
      }
    } else if (typeof value === 'object') {
      if (!allLeafNodesEqual(value)) {
        return false;
      }
    }
  }
  return true;
};
